import { JwtAxios } from '@/packaging';

export const cafe24Api = {
  // 템플릿 조회
  async GetCafe24Template(marketAccount, marketIdx) {
    const responseModel = await JwtAxios.get(
      `/Template/Market/GetCafe24ApiTemplate?marketAccount=${marketAccount}&marketIdx=${marketIdx}`
    );
    return responseModel;
  },
  // 출고지 목록 조회
  async GetCafe24Shipment(marketAccount, marketIdx) {
    const responseModel = await JwtAxios.get(
      `/Template/Market/GetCafe24ApiShipment?marketAccount=${marketAccount}&marketIdx=${marketIdx}`
    );
    return responseModel;
  },
  // 택배사 목록 조회
  async GetCafe24DeliveryCompany(marketAccount, marketIdx) {
    const responseModel = await JwtAxios.get(
      `/Template/Market/GetCafe24ApiDeliveryCompany?marketAccount=${marketAccount}&marketIdx=${marketIdx}`
    );
    return responseModel;
  },
  // 지역별 추가배송비 조회
  async GetCafe24RegionCharging(marketAccount, marketIdx) {
    const responseModel = await JwtAxios.get(
      `/Template/Market/GetCafe24ApiRegionCharging?marketAccount=${marketAccount}&marketIdx=${marketIdx}`
    );
    return responseModel;
  },
  // 쇼핑몰 기본정보 조회
  async GetCafe24Store(marketAccount, marketIdx) {
    const responseModel = await JwtAxios.get(
      `/Template/Market/GetCafe24ApiStore?marketAccount=${marketAccount}&marketIdx=${marketIdx}`
    );
    return responseModel;
  },
  // 표준카테고리 수 + 생성 진행상황 조회
  async GetCafe24StandardCategoryInfo(marketAccount, marketIdx) {
    const responseModel = await JwtAxios.get(
      `/Template/Market/GetCafe24StandardCategoryInfo?marketAccount=${marketAccount}&marketIdx=${marketIdx}`
    );
    return responseModel;
  },
  // 표준카테고리 일괄 생성 시작 (백그라운드)
  async CreateCafe24StandardCategory(marketAccount, marketIdx) {
    const responseModel = await JwtAxios.post(
      `/Template/Market/CreateCafe24StandardCategory?marketAccount=${marketAccount}&marketIdx=${marketIdx}`
    );
    return responseModel;
  },
  // 표준카테고리 생성 진행상황 조회
  async GetCafe24StandardCategoryProgress(marketAccount, marketIdx) {
    const responseModel = await JwtAxios.get(
      `/Template/Market/GetCafe24StandardCategoryProgress?marketAccount=${marketAccount}&marketIdx=${marketIdx}`
    );
    return responseModel;
  },
  // 템플릿 저장
  async SetCafe24Template(model) {
    const responseModel = await JwtAxios.post(`/Template/Market/SetCafe24ApiTemplate`, model);
    return responseModel;
  },
  // 계정 저장
  async SetCafe24Account(connectionId, model) {
    const responseModel = await JwtAxios.post(
      `/Template/Market/SetCafe24Account?connectionId=${connectionId}`,
      model
    );
    return responseModel;
  }
};
